import styled from "styled-components";
import {
  colors,
  easing,
  fadeUp,
  fonts,
  layout,
  media,
  radii,
  shadows,
} from "../../../theme";

export const HighlightsSection = styled.section`
  display: flow-root;
  padding: 0 ${layout.gutter};
  background-color: ${colors.backgroundSecondary};
`;

export const HighlightsCard = styled.div`
  position: relative;
  z-index: 2;
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  max-width: 960px;
  margin: -4rem auto 0;
  padding: 2rem 1rem;
  border-radius: ${radii.lg};
  background-color: ${colors.backgroundSecondary};
  box-shadow: ${shadows.lg};
  scroll-margin-top: calc(${layout.navHeightCompact} + 1.5rem);
  animation: ${fadeUp} 1s ${easing.out} 0.8s both;

  > * + * {
    border-left: 1px solid rgba(210, 180, 140, 0.45);
  }

  ${media.mobile} {
    margin-top: -3rem;
    padding: 1.5rem 0.25rem;
  }
`;

export const Highlight = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.25rem;
  padding: 0 1rem;
  text-align: center;
  animation: ${fadeUp} 0.9s ${easing.out} ${({ $index }) => 1 + $index * 0.12}s
    both;

  ${media.mobile} {
    padding: 0 0.5rem;
  }
`;

export const HighlightValue = styled.span`
  font-family: ${fonts.heading};
  font-size: clamp(2rem, 4.5vw, 3rem);
  font-weight: 600;
  line-height: 1.1;
  color: ${colors.textSecondary};
`;

export const HighlightLabel = styled.span`
  font-size: 0.95rem;
  line-height: 1.35;
  color: ${colors.textMuted};

  ${media.mobile} {
    font-size: 0.8rem;
  }
`;
